import { useConstant } from '@visiba/react-std';
import { Timer } from '@visiba/std';
import { ReactNode, useEffect, useState } from 'react';

interface Props<T> {
	delay?: number;
	derive: T | null;
	children: ((data: NonNullable<T>) => ReactNode) | ReactNode;
	fallback: ReactNode;
}

export function Async<T>(props: Props<T>): JSX.Element {
	const timer = useConstant(() => new Timer());
	const [uiTimeout, setUiTimeout] = useState(props.derive == null);

	useEffect(() => {
		return timer.wait(() => {
			setUiTimeout(false);
		}, props.delay ?? 250);
	}, [timer, props.delay]);

	if (uiTimeout || props.derive == null) return <>{props.fallback}</>;

	return <>{typeof props.children === 'function' ? props.children(props.derive) : props.children}</>;
}
